import { AGGREGATED_ONBOARDING_MODAL_PC_MAX_HEIGHT } from "./aggregatedOnboardingModalShell";

/**
 * 聚合 ⑦⑧ 步内布局 token（`layout="aggregated"`）。
 * PC 步根须 cap `max-height` 并 `overflow-hidden`，中间区才能 `flex-1` 滚动。
 */
export const AGGREGATED_ONBOARDING_STEP_PC_MAX_HEIGHT =
  AGGREGATED_ONBOARDING_MODAL_PC_MAX_HEIGHT;

/** 中间滚动区 — 对齐 Plan Gate `checkedFindingsScrollClass` */
export const AGGREGATED_ONBOARDING_SCROLL_CLASS =
  "min-h-0 flex-1 flex-col overflow-x-hidden overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch]";

/** 聚合步外壳：H5 全屏 flex 链；PC `max-h-[90dvh]` 封顶以启用步内滚动 */
export const AGGREGATED_ONBOARDING_STEP_ROOT_CLASS =
  "flex h-full min-h-0 w-full flex-col overflow-hidden bg-background_solid_secondary pt-safe pb-safe md:max-h-[90dvh] md:pb-0";

/** 聚合步内列：header / scroll / footer 三分 */
export const AGGREGATED_ONBOARDING_STEP_COLUMN_CLASS =
  "flex min-h-0 flex-1 flex-col overflow-hidden";

/** 底栏 CTA 区 — H5 外壳 `pb-safe` + 按钮 `mb-3`；PC `pb-6` */
export const AGGREGATED_ONBOARDING_FOOTER_CLASS =
  "shrink-0 px-4 pt-3 md:px-6 md:pt-4 md:pb-6";

/** 聚合态主 CTA — 双端全宽 */
export const AGGREGATED_ONBOARDING_CTA_CLASS =
  "button button_m md_button primary_button flex h-11 w-full items-center justify-center rounded-2";
